import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonPipesModule } from './common-pipes/common-pipes.module';
import { UpgradeCTADialogModule } from './get-pro-dialog/get-pro-dialog.module';
import { VaGoalTableModule } from './goal-table/goal-table.module';
import { ProjectMilestonesComponent } from './project-milestones/project-milestones.component';
import { VaSanitizePipe } from './safe-html/safe-html.pipe';
import { VaSearchBoxModule } from './search-box/va-search-box.module';
import { VaActionMenuComponent } from './va-action-menu/va-action-menu.component';
import { VaBadgeComponent } from './va-badge/va-badge.component';
import { VaBreadcrumbsModule } from './va-breadcrumbs/va-breadcrumbs.module';
import { VaCardsModule } from './va-cards/va-cards.module';
import { VaFilterChipsModule } from './va-filter-chips/va-filter-chips.module';
import { VaFilterModule } from './va-filter/filter.module';
import { VaIconModule } from './va-icon/icon.module';
import { VaImageGalleryComponent } from './va-image-gallery';
import { ItemsAndStatusComponent } from './va-items-and-status/va-items-and-status.component';
import { VaListModule } from './va-list/va-list.module';
import { VaMaterialTableModule } from './va-mat-table/va-mat-table.module';
import { VaMultiSelectComponent } from './va-multi-select/va-multi-select.component';
import { VaNavItemListComponent } from './va-nav/nav-item-list/nav-item-list.component';
import { VaNavItemComponent } from './va-nav/nav-item/nav-item.component';
import { VaNavComponent } from './va-nav/nav.component';
import { VaNestedSelectorModule } from './va-nested-selector/va-nested-selector.module';
import { VaProductNavModule } from './va-product-nav/va-product-nav.module';
import { VaSearchSelectModule } from './va-search-select/va-search-select.module';
import { VaStatusBannerComponent } from './va-status-banner/va-status-banner.component';
import { VaTableModule } from './va-table/table.module';
import { WelcomeModule } from './va-welcome/welcome.module';
import { VaButtonComponent } from './wrappers/va-button/va-button.component';
import { VaCheckboxComponent } from './wrappers/va-checkbox/va-checkbox.component';
import { VaChipComponent } from './wrappers/va-chip/va-chip.component';
import { VaExpandDirective } from './wrappers/va-expand/va-expand.directive';
import { VaMenuComponent } from './wrappers/va-menu/va-menu.component';
import { VaMultilineComponent } from './wrappers/va-multiline/va-multiline.component';
import { VaSwitchComponent } from './wrappers/va-switch/va-switch.component';

@NgModule({
  imports: [
    VaCardsModule,
    CommonModule,
    VaSearchBoxModule,
    VaIconModule,
    VaTableModule,
    VaButtonComponent,
    VaCheckboxComponent,
    VaMenuComponent,
    VaExpandDirective,
    VaSwitchComponent,
    VaMultilineComponent,
    VaFilterModule,
    ItemsAndStatusComponent,
    VaMultiSelectComponent,
    VaSearchSelectModule,
    VaChipComponent,
    VaSanitizePipe,
    VaImageGalleryComponent,
    VaListModule,
    VaActionMenuComponent,
    VaNestedSelectorModule,
    VaBreadcrumbsModule,
    VaNavComponent,
    VaNavItemComponent,
    VaNavItemListComponent,
    VaProductNavModule,
    CommonPipesModule,
    VaBadgeComponent,
    UpgradeCTADialogModule,
    WelcomeModule,
    VaMaterialTableModule,
    VaFilterChipsModule,
    VaStatusBannerComponent,
    ProjectMilestonesComponent,
    VaGoalTableModule,
  ],
  exports: [
    VaCardsModule,
    CommonModule,
    VaSearchBoxModule,
    VaIconModule,
    VaTableModule,
    VaButtonComponent,
    VaCheckboxComponent,
    VaMenuComponent,
    VaExpandDirective,
    VaSwitchComponent,
    VaMultilineComponent,
    VaFilterModule,
    ItemsAndStatusComponent,
    VaMultiSelectComponent,
    VaSearchSelectModule,
    VaChipComponent,
    VaSanitizePipe,
    VaImageGalleryComponent,
    VaListModule,
    VaActionMenuComponent,
    VaNestedSelectorModule,
    VaBreadcrumbsModule,
    VaNavComponent,
    VaNavItemComponent,
    VaNavItemListComponent,
    VaProductNavModule,
    CommonPipesModule,
    VaBadgeComponent,
    UpgradeCTADialogModule,
    WelcomeModule,
    VaMaterialTableModule,
    VaFilterChipsModule,
    VaStatusBannerComponent,
    ProjectMilestonesComponent,
    VaGoalTableModule,
  ],
})
export class UIKitModule {}
